/*
  VSB reviews dashboard (sections/vsb-reviews): the filters. A histogram row
  shows only that many stars; a "used for" chip only those reviews; "Verified
  buyer" only verified ones. Choosing a filter opens the folded reviews too
  (d-reveal, vsb-base.js), so nothing matching stays hidden. Set up once the
  section nears the screen (vsbWhenNear), or on first focus.
*/

if (!customElements.get('d-review-board')) {
  customElements.define('d-review-board', class extends HTMLElement {
    connectedCallback() {
      this.init = this.init.bind(this);
      this.addEventListener('focusin', this.init, { once: true });
      if (window.vsbWhenNear) window.vsbWhenNear(this, this.init); else this.init();
    }

    init() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.filter = {};
      this.querySelectorAll('[data-filter-stars]').forEach((b) => b.addEventListener('click', () => this.set({ stars: this.filter.stars === b.dataset.filterStars ? null : b.dataset.filterStars })));
      this.querySelectorAll('[data-filter-use]').forEach((b) => b.addEventListener('click', () => this.set({ use: this.filter.use === b.dataset.filterUse ? null : b.dataset.filterUse })));
      this.querySelector('[data-filter-verified]')?.addEventListener('click', () => this.set({ verified: !this.filter.verified }));
      this.querySelector('[data-filter-all]')?.addEventListener('click', () => { this.filter = {}; this.apply(); });
    }

    set(change) {
      Object.assign(this.filter, change);
      this.apply();
    }

    apply() {
      const f = this.filter;
      const any = Boolean(f.stars || f.use || f.verified);
      if (any) this.querySelector('d-reveal')?.removeAttribute('data-collapsed');
      let shown = 0;
      this.querySelectorAll('.d-review, .d-dm').forEach((card) => {
        const ok = !any || (card.classList.contains('d-review')
          && (!f.stars || card.dataset.stars === f.stars)
          && (!f.use || card.dataset.use === f.use)
          && (!f.verified || card.hasAttribute('data-verified')));
        card.hidden = !ok;
        if (ok) shown++;
      });
      this.querySelectorAll('[data-filter-stars]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filterStars === f.stars)));
      this.querySelectorAll('[data-filter-use]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filterUse === f.use)));
      this.querySelector('[data-filter-verified]')?.setAttribute('aria-pressed', String(Boolean(f.verified)));
      this.querySelector('[data-filter-all]')?.setAttribute('aria-pressed', String(!any));
      const none = this.querySelector('.d-board__none');
      if (none) none.hidden = shown > 0;
    }
  });
}
